import { render, staticRenderFns } from "./NotFoundParagraph.vue?vue&type=template&id=4b567c4c&"
import script from "./NotFoundParagraph.vue?vue&type=script&lang=js&"
export * from "./NotFoundParagraph.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundParagraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports